import { get } from 'lodash';

import getVersionlessApp from '../../../utils/getVersionlessApp';

import { Fixtures } from './types';
import { App, Action, NeedResponse, ZDL } from '../types';
import { Params } from '../../shared/types';

/**
 * If a needs-altering function exists in the fixtures for the given app and action,
 * return the result of that function. Otherwise, return the unaltered needs.
 */
export const mergeNeedsFixture = (
  fixtures: Fixtures,
  appKey: App['selected_api'],
  actionKey: Action['key'],
  needs: NeedResponse[]
): NeedResponse[] => {
  const needsBuilder = get(fixtures, [
    getVersionlessApp(appKey),
    actionKey,
    'needs',
  ]);
  return needsBuilder ? needsBuilder(needs) : needs;
};

/**
 * If a params-altering function exists in the fixtures for the given app and action,
 * return the result of that function. Otherwise, return the unaltered params.
 */
export const mergeParamsFixture = (
  fixtures: Fixtures,
  appKey: App['selected_api'],
  actionKey: Action['key'],
  params: Params
): Params => {
  const paramsBuilder = get(fixtures, [
    getVersionlessApp(appKey),
    actionKey,
    'params',
  ]);
  return paramsBuilder ? paramsBuilder(params) : params;
};

/** Merge param fixtures for every step of a ZDL zap. */
export const mergeParamsFixturesIntoZDL = (
  fixtures: Fixtures,
  zdl: ZDL
): ZDL => {
  zdl.steps = zdl.steps.map((step) => {
    step.params = mergeParamsFixture(
      fixtures,
      step.app,
      step.action,
      step.params
    );
    return step;
  });
  return zdl;
};
